<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card>
      <!-- popup -->

      <!--  -->
      <b-modal
        id="custom-modal"
        :title="$t('UpgradePlan')"
        v-model="newPopup"
        centered
        hide-footer
        no-close-on-backdrop
      >
        <!-- <div v-if="newPopup1">
          <div>
            <h3 class="align-center">{{ $t("SeatNotAvailable") }}</h3>
          </div>
          <div class="mt-5 export-table notes">
            <b-row class="purchase">
              <b-col>
                <b-button
                  variant="primary"
                  @click="upgradeForm"
                  id="card-button"
                  class="float-right"
                >
                  <span>{{ $t("Upgrade") }}</span>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div> -->
        <!-- popup-2 -->
        <div v-if="newPopup2">
          <div>
            <h3 class="align-center">{{ $t("UpgradeYourPlan") }}</h3>
          </div>
          <form method="post" v-on:submit.prevent="$event.preventDefault()">
            <div class="vx-row">
              <div class="vx-col w-1/2 mt-5">
                <label class="vs-input--label"
                  >{{ $t("Plan") }} <span class="red">*</span></label
                >
                <v-select
                  v-validate="'required'"
                  v-model="plan"
                  :options="planOptions"
                  :reduce="(name) => name.slug"
                  label="name"
                  :placeholder="$t('SelectPlan')"
                  :data-vv-as="$t('Plan')"
                  name="plan"
                  ><template v-slot:option="option">
                    <span :class="option.icon">{{ option.slug }} </span>
                    <feather-icon
                      v-if="plan == option.slug"
                      icon="CheckIcon"
                      class="float-right"
                      svgClasses="w-5 h-5"
                    />
                  </template>
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('plan')">{{
                  errors.first("plan")
                }}</span>
              </div>
              <div class="vx-col w-1/2 mt-5">
                <label class="vs-input--label"
                  >{{ $t("Seats") }} <span class="red">*</span></label
                >
                <v-select
                  v-validate="'required'"
                  v-model="seat"
                  :options="seats"
                  label="name"
                  :placeholder="$t('Select Seat')"
                  :data-vv-as="$t('Seat')"
                  name="seat"
                  ><template v-slot:option="option">
                    <span :class="option.icon">{{ option.name }} </span>
                    <feather-icon
                      v-if="seat == option.name"
                      icon="CheckIcon"
                      class="float-right"
                      svgClasses="w-5 h-5"
                    />
                  </template>
                </v-select>
                <span class="text-danger text-sm" v-show="errors.has('seat')">{{
                  errors.first("seat")
                }}</span>
              </div>
            </div>
            <div class="mt-5 export-table notes">
              <b-row class="purchase">
                <b-col>
                  <b-button
                    variant="primary"
                    @click="submitPlan"
                    id="card-button"
                    class="float-right"
                  >
                    <span>{{ $t("Checkout") }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </form>
        </div>
        <!-- popup-3 -->
        <div v-if="newPopup3" class="charge">
          <div>
            <h3 class="align-center">{{ $t("YourNewPlan") }}</h3>
          </div>
          <div class="mt-5 export-table notes ml-5 mr-5">
            <b-row>
              <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
                <td class="font-semibold">
                  {{ $t("StandardPlan") + seat + $t("SeatPlan") }}
                </td>
              </b-col>
              <b-col
                vs-type="flex"
                vs-justify="right"
                vs-align="right"
                vs-w="6"
              >
                <!-- <td> -->
                <span class="float-right">&euro;{{ subtotal }}</span>
                <br />
                <p class="float-right">{{ $t("Billed") }}</p>
                <!-- </td> -->
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
                <td>
                  <span class="flex font-semibold"
                    >{{ $t("LeftoverBalance") }}
                    <vx-tooltip
                      position="top"
                      :text="$t('Remain1') + remaining_days + $t('Remain2')"
                    >
                      <feather-icon
                        icon="AlertCircleIcon"
                        svgClasses="h-7 w-7 stroke-current text-grey"
                        class="block ml-5"
                      />
                    </vx-tooltip>
                  </span>
                  <p>{{ $t("FromYour") }}</p>
                </td>
              </b-col>
              <b-col
                vs-type="flex"
                vs-justify="right"
                vs-align="right"
                vs-w="6"
              >
                <!-- <td> -->
                <span class="float-right">- &euro;{{ left_balance }}</span>
                <!-- </td> -->
              </b-col>
            </b-row>
            <hr
              class="mt-5"
              style="
                height: 1px;
                border-width: 0;
                color: gray;
                background-color: gray;
              "
            />
            <b-row class="mt-5">
              <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
                <td class="font-semibold">{{ $t("Total") }}</td>
              </b-col>
              <b-col
                vs-type="flex"
                vs-justify="right"
                vs-align="right"
                vs-w="6"
              >
                <!-- <td> -->
                <span class="float-right font-semibold">&euro;{{ total }}</span>
                <!-- </td> -->
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
                <td>
                  <p style="font-size: 13px">
                    {{ $t("NextChargeDate") + expiry_date }}
                  </p>
                </td>
              </b-col>
            </b-row>
            <b-row class="purchase">
              <b-col>
                <b-button
                  :variant="'primary'"
                  @click="checkCard"
                  id="card-button"
                  class="float-right"
                >
                  <span>{{ $t("SubmitPurchase") }}</span>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-modal>
      <!--  -->

      <!--  -->
    </b-card>
  </b-overlay>
</template>
<script>
import vSelect from "vue-select";
import moment from "moment";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  phoneConfig,
  getLanguage,
  getRoles,
  getFilteredRoles,
} from "@/utils/helper";
import $ from "jquery";
// For custom error message
import { Validator } from "vee-validate";

export default {
  components: {
    FormWizard,
    TabContent,
    "v-select": vSelect,
  },
  props: {
    added: Boolean,
  },
  data() {
    return {
      department: this.$t("DepartmentName"),
      departments: [],
      companies: [],
      options: [],
      values: [],
      plan: "",
      planOptions: [],
      seat: "",
      seats: [1, 3, 5, 10, 15, 20, 25, 30, 40, 50, 100],
      total: "",
      subtotal: "",
      left_balance: "",
      expiry_date: "",
      remaining_days: "",
      staffs: [
        {
          first_name: "",
          last_name: "",
          department_id: "",
          company_id: "",
          email: "",
          contact_number: "",
          password: "",
          language: "",
          user_role: "staff",
          is_device: false,
        },
      ],
      bindProps: phoneConfig(this.$t("ContactNumber")),
      languages: getLanguage(this.$t("lang")),
      roles: getRoles(this.$t("roles")),
      selected: "staff",
      staff_id: "",
      newPopup: false,
      newPopup1: false,
      newPopup2: false,
      newPopup3: false,
      source: "",
      charge: [],
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.departmentValidation();
        this.bindProps = phoneConfig(this.$t("ContactNumber"));
        this.roles = getRoles(this.$t("roles"));
        this.languages = getLanguage(this.$t("lang"));
      },
    },
    added(value) {
      value && this.cardAdd();
    },
  },

  created() {
    this.newPopup = true;
    this.newPopup2 = true;
    // this.newPopup1 = true;
    this.getPlan();
    this.bindProps.disabledFetchingCountry = false;
  },

  methods: {
    cardAdd() {
      let card_id = this.$store.getters.currentUser.card_id || "";
      let cardLength = card_id.length;
      if (cardLength) {
        this.submitPlan();
        this.purchasePlan();
      }
    },
    checkCard() {
      let card_id = this.$store.getters.currentUser.card_id || "";
      let cardLength = card_id.length;
      this.$emit("lengthCard", cardLength);
      if (!cardLength) {
        this.close();
      }
      cardLength && this.purchasePlan();
    },
    upgradeForm() {
      this.newPopup1 = false;
      this.newPopup2 = true;
    },
    submitPlan() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.show = true;
          var data = {
            company_id: this.$store.getters.currentUser.id,
            seats: this.seat,
            plan_slug: this.plan,
          };

          // console.log("rahul123",data)
          this.$store.dispatch("PaymentCheckout", data).then((response) => {
            this.show = false;
            this.newPopup2 = false;
            this.newPopup3 = true;
            this.total = response.data.data.total;
            this.subtotal = response.data.data.subtotal;
            this.left_balance = response.data.data.left_balance;
            this.remaining_days = response.data.data.remaining_days;
            this.expiry_date = moment(response.data.data.expiry_date).format(
              "LL"
            );
          });
        } else {
          return false;
        }
      });
    },
    /*function for get plan
      Here index is the day value
    */

    purchasePlan() {
      this.show = true;
      var data = {
        company_id: this.$store.getters.currentUser.id,
        total: this.total,
        seats: this.seat,
        plan_slug: this.plan,
      };
      this.$store
        .dispatch("PurchasePlan", data)
        .then((response) => {
          console.log("response12312321---------", response);
          this.newPopup3 = false;
          this.newPopup = false;

          this.show = false;
          this.charge = response.data.data;
          //   if (this.charge.id) this.addstaffs();
          this.$toasted.show(this.$t("SaveTransactionPlan"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.show = false;
          console.log("purchase-plan--error", error);
          // Error response
          this.error = this.$t("PurchaseFailed");
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    getPlan() {
      //Call API for get plan
      this.$store.dispatch("GetCompanyPlan").then((response) => {
        if (response.data.seat_count) {
          this.seat = response.data.seat_count;
          let count = this.seat;

          let filterSeats = this.seats.filter(function (number) {
            return (number = count);
          });
          this.seats = filterSeats;
          if (filterSeats[0]) {
            this.seat = filterSeats[0];
          }
        }

        this.planOptions = response.data.plans;
        if (this.$store.getters.currentUser.plan_name != "trial") {
          let oldPlan = this.$store.getters.currentUser.plan_name;
          let filterPlan = this.planOptions.filter(function (plan) {
            return oldPlan == plan.slug;
          });
          this.planOptions = filterPlan;
          this.planOptions.map((element, index) => {
            this.plan = element.slug;
          });
        } else {
          this.planOptions.map((element, index) => {
            if (element.name == "Professional") {
              this.plan = element.slug;
            }
          });
        }
      });
    },

    /**
     *  checkForm method for check form
     **/
    close() {
      this.newPopup = false;
      this.newPopup1 = false;
      this.newPopup2 = false;
      this.newPopup3 = false;
    },
  },
};
</script>

<style>
.align-center {
  text-align: center;
}

.purchase {
  display: block !important;
}

#department {
  margin-top: 20px;
}

#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.contact_number {
  padding: 8px !important;
}

#contact_label {
  margin-top: 15px;
}

.charge td {
  width: 100%;
}
</style>










